/**
 * Create Plan Tool - Prompt & Guidelines
 * 
 * Tool description and usage guidelines for creating presentation plans.
 */

// ═══════════════════════════════════════════════════════════════════════════
// TOOL DESCRIPTION
// ═══════════════════════════════════════════════════════════════════════════

export const CREATE_PLAN_TOOL_DESCRIPTION = `Create a presentation outline with sections and slides. Use this ONLY for the initial plan creation.

Guidelines:
- Create logical section groupings (typically 3-8 sections for most decks)
- Distribute slides appropriately across sections (avoid 1-slide or 30+ slide sections)
- Write clear, specific slide purposes that describe what the slide should communicate
- Align structure with user's stated goals and any research findings
- Each section must have at least one slide
- targetSlideCount is optional and can be approximate (±5 slides acceptable)

System will automatically:
- Generate unique IDs for all sections and slides
- Calculate total slide and section counts
- Assign index positions to slides within sections`;

// ═══════════════════════════════════════════════════════════════════════════
// SECTION SIZING GUIDELINES
// ═══════════════════════════════════════════════════════════════════════════

export const SECTION_SIZING_GUIDELINES = `
**Section sizing guidelines:**
- Small decks (10-20 slides): 2-3 sections, 5-8 slides per section
- Medium decks (20-50 slides): 4-6 sections, 6-10 slides per section
- Large decks (50-100 slides): 7-10 sections, 8-15 slides per section`;

// ═══════════════════════════════════════════════════════════════════════════
// PRESENTATION ARCHETYPES
// ═══════════════════════════════════════════════════════════════════════════

export const PRESENTATION_ARCHETYPES = `
**Common presentation archetypes:**
- Board deck: Strategic overview, financial performance, key decisions
- Pitch deck: Problem, solution, market, traction, team, ask
- QBR (Quarterly Business Review): Metrics, progress, challenges, next quarter
- Investor update: Performance highlights, financials, roadmap
- Product launch: Vision, features, benefits, pricing, timeline
- Training deck: Objectives, concepts, examples, exercises, summary`;
